import { render, staticRenderFns } from "./nutritionCustomers.vue?vue&type=template&id=77412abd"
import script from "./nutritionCustomers.vue?vue&type=script&lang=js"
export * from "./nutritionCustomers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports